module.exports = __webpack_public_path__ + "media/packs/images/flags/TZ-b5f375baf8e5f0fd131d451df267e8e8.svg";